export default "assets/images/icons/chat-421f2782.svg";